import { Tooltip, Modal } from 'bootstrap'

import '../scss/main.scss';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))

if(document.querySelectorAll('.js-offcanvas-toggle').length > 0 && document.querySelector('.js-offcanvas-nav')) {
    const offcanvas = document.querySelector('.js-offcanvas-nav')

    document.querySelectorAll('.js-offcanvas-toggle').forEach(el => {
        el.addEventListener('click', () => {
            const isHidden = offcanvas.getAttribute('aria-hidden') === 'true';
            const newState = !isHidden;

            offcanvas.setAttribute('aria-hidden', newState.toString());
        });
    });
}
if(document.querySelectorAll('.js-search-toggle').length > 0 && document.querySelector('.js-page-header_search')) {
    const searchWrapper = document.querySelector('.js-page-header_search')

    document.querySelectorAll('.js-search-toggle').forEach(el => {
        el.addEventListener('click', () => {
            if (!searchWrapper.classList.contains('is-active')) {
                searchWrapper.classList.add('is-active');
                document.querySelector('.js-page-header_search input').focus();
            } else {
                searchWrapper.classList.remove('is-active');
            }
        });
    });
    window.addEventListener('resize', () => {
        if (!document.querySelector('.js-page-header_search input:focus')) {
            searchWrapper.classList.remove('is-active');
        }
    });
}

if(document.querySelector('.js-offcanvas-nav-backdrop')) {
    document.querySelector('.js-offcanvas-nav-backdrop').addEventListener('click', () => {
        document.querySelector('.js-offcanvas-toggle').click();
    });
}

let root = document.documentElement;
const clientWidth = document.documentElement.clientWidth;
root.style.setProperty('--c-width', clientWidth + "px");
window.addEventListener('resize', e => {
    const clientWidth = document.documentElement.clientWidth;
    root.style.setProperty('--c-width', clientWidth + "px");
});

let lsApsSearch = localStorage.getItem('aps_search');
if (lsApsSearch != null) {
    const pathname  = window.location.pathname;
    if (pathname.includes('/suche') === false && pathname.includes('/dokument') === false) {
        localStorage.removeItem('aps_search');
    }
}

document.querySelectorAll("a[href^='#']").forEach(link => {
    link.addEventListener("click", e => {
        const target = document.querySelector(link.hash);

        if (!target) return;

        e.preventDefault();

        target.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    let url = window.location.toString();
    if (url.indexOf("#") > 0) {
        url = url.substring(0, url.indexOf("#"));
    }
    if (url.indexOf("?") > 0) {
        url = url.substring(0, url.indexOf("?"));
    }

    fetch(url + '?type=7356555', {
        method: 'POST',
        headers: {
            'Content-Type': 'text/html'
        }
    })
        .then(response => response.text())
        .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            const newAccountDiv = doc.querySelector('#account');
            const newAccountNavDiv = doc.querySelector('#account-nav');

            if (newAccountDiv) {
                const oldAccount = document.querySelector('#account');
                if (oldAccount) {
                    oldAccount.replaceWith(newAccountDiv);
                }
            }

            if (newAccountNavDiv) {
                const oldAccountNav = document.querySelector('#account-nav');
                if (oldAccountNav) {
                    oldAccountNav.replaceWith(newAccountNavDiv);
                }
            }
        });
});
